/* US-Parts24 · R572 — Drohnenfilm (sections/usparts-drohnenfilm.liquid).
   Lädt den Film erst, wenn der Abschnitt näher als zwei Bildschirme ist, spielt
   nur sichtbar, hält außerhalb und im Hintergrund-Tab an. Die Anzeige
   (Takte, Einstellung, Flughöhe) folgt dem Film Bild für Bild.

   Nähe wird per getBoundingClientRect an einem Scroll-Hörer (Capture) gemessen,
   nicht per IntersectionObserver-rootMargin: am Rechner scrollt .page-wrapper
   (Lenis), und dessen Überlauf schneidet den Vorlauf-Rand ab. */
(() => {
  const ruhig = matchMedia('(prefers-reduced-motion: reduce)');
  const sparen = !!(navigator.connection && navigator.connection.saveData);
  const rvfc = 'requestVideoFrameCallback' in HTMLVideoElement.prototype;

  function starten(root) {
    if (root.dataset.udfAn) return;
    root.dataset.udfAn = '1';
    root.classList.add('udf--js');

    const film = root.querySelector('.udf__film');
    const schnitte = root.dataset.schnitte.split(',').map(Number);
    const hoehen = root.dataset.hoehen.split(',');
    const takte = [...root.querySelectorAll('.udf__takte i')];
    const nr = root.querySelector('[data-udf-nr]');
    const hoehe = root.querySelector('[data-udf-hoehe]');
    const knopf = root.querySelector('[data-udf-pause]');
    const ohneFilm = ruhig.matches || sparen || !film;

    let geladen = false, sichtbar = false, angehalten = false, schleifeAn = false;
    let takt = -1, sek = -1;

    const laden = () => {
      if (geladen || ohneFilm) return;
      geladen = true;
      film.src = matchMedia('(max-width: 749px)').matches ? root.dataset.filmM : root.dataset.filmD;
      film.preload = 'auto';
      film.load();
      spielen();
    };
    const spielen = () => {
      if (!geladen || angehalten || !sichtbar || document.hidden) return;
      const p = film.play();
      if (p && p.catch) p.catch(() => {}); // Stromsparmodus u. Ä.: Standbild bleibt
    };
    const anhalten = () => { if (!film.paused) film.pause(); };

    const zeichnen = () => {
      const t = film.currentTime;
      let k = schnitte.findIndex((x) => t < x);
      if (k < 0) k = schnitte.length - 1;
      if (k !== takt) {
        takte.forEach((el, i) => { if (i !== k) el.style.transform = i < k ? 'scaleX(1)' : 'scaleX(0)'; });
        nr.textContent = String(k + 1).padStart(2, '0');
        takt = k;
      }
      const von = k ? schnitte[k - 1] : 0;
      takte[k].style.transform = `scaleX(${Math.min(1, Math.max(0, (t - von) / (schnitte[k] - von))).toFixed(3)})`;
      const s = Math.min(hoehen.length - 1, Math.floor(t));
      if (s !== sek) { hoehe.textContent = hoehen[s]; sek = s; }
    };
    const weiter = () => (rvfc ? film.requestVideoFrameCallback(schleife) : requestAnimationFrame(schleife));
    function schleife() {
      zeichnen();
      if (film.paused) { schleifeAn = false; return; }
      weiter();
    }

    if (!ohneFilm) {
      film.addEventListener('playing', () => {
        root.classList.add('is-laeuft');
        if (!schleifeAn) { schleifeAn = true; weiter(); }
      });
      document.addEventListener('visibilitychange', () => (document.hidden ? anhalten() : spielen()));
      knopf.addEventListener('click', () => {
        angehalten = !angehalten;
        root.classList.toggle('is-angehalten', angehalten);
        knopf.setAttribute('aria-pressed', String(angehalten));
        knopf.setAttribute('aria-label', angehalten ? 'Film abspielen' : 'Film anhalten');
        angehalten ? anhalten() : spielen();
      });
    }

    /* Vorlauf: zwei Bildschirme vorher laden, dann Hörer weg */
    const naehe = () => {
      const r = root.getBoundingClientRect();
      if (r.top < innerHeight * 2 && r.bottom > -innerHeight) {
        laden();
        document.removeEventListener('scroll', naehe, true);
      }
    };
    document.addEventListener('scroll', naehe, { capture: true, passive: true });
    naehe();

    /* Sichtbar: abspielen + Text-Auftritt (einmal) */
    new IntersectionObserver((eintraege) => {
      sichtbar = eintraege[eintraege.length - 1].isIntersecting;
      if (sichtbar) { root.classList.add('is-da'); laden(); spielen(); }
      else anhalten();
    }, { threshold: 0.2 }).observe(root);
  }

  const alle = () => document.querySelectorAll('[data-udf]').forEach(starten);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle);
  else alle();
  document.addEventListener('shopify:section:load', alle);
})();
